import { Operation } from '../openApiSpec/Operation';
import { RequestSampleAttribute } from './Attribute';

export class RequestSampleOperation {
  id!: string;
  name!: string;
  description!: string;
  path?: string;
  httpMethod?: string;
  methodName?: string;
  notes?: string;
  isListOperation?: boolean;
  isIdempotent?: boolean;
  isRestricted?: boolean;
  isCustomFieldsSupported?: boolean;
  required?: string[] | boolean;
  pathAttributes?: RequestSampleAttribute[] | undefined;
  queryAttributes?: RequestSampleAttribute[] | undefined;
  sourceQueryAttributes?: RequestSampleAttribute[] | undefined;
  sortAttributes?: RequestSampleAttribute[] | undefined;
  sourceSortAttributes?: RequestSampleAttribute[] | undefined;
  attributes?: RequestSampleAttribute[] | undefined;
  sourceAttributes?: RequestSampleAttribute[] | undefined;
  filterAttributes?: RequestSampleAttribute[] | undefined;
  sourceFilterAttributes?: RequestSampleAttribute[] | undefined;
  returns?: RequestSampleAttribute[] | undefined;
  resourceKey: string;
  #openApiOperation?: Operation;
  subDomain?: string;

  constructor(operation?: Operation, required?: string[] | boolean) {
    this.#openApiOperation = operation;
    this.resourceKey = operation?.resourceId ?? '';
    this.required = required;
  }

  toJson() {
    if (this.#openApiOperation != null) {
      this.id = this.#openApiOperation.id;
      this.resourceKey = this.#openApiOperation.resourceId;
      this.description = this.#openApiOperation.description;
      this.path = this.#openApiOperation.path;
      this.httpMethod = this.#openApiOperation.httpMethod;
      this.methodName = this.#openApiOperation.methodName;
      this.notes = this.#openApiOperation.notes;
      this.isListOperation = this.#openApiOperation.isListOperation;
      this.isIdempotent = this.#openApiOperation.isIdempotent;
      this.isRestricted = this.#openApiOperation.isRestricted;
      this.isCustomFieldsSupported =
        this.#openApiOperation.isCustomFieldsSupported;
      this.name = this.#openApiOperation.name;
      this.subDomain = this.#openApiOperation?.subDomain;
      this.attributes = RequestSampleAttribute.parse(
        false,
        this.#openApiOperation.properties
      );
      this.sourceAttributes = JSON.parse(JSON.stringify(this.attributes));
      this.queryAttributes = RequestSampleAttribute.parse(
        false,
        this.#openApiOperation.queryProperties
      );
      this.sourceQueryAttributes = RequestSampleAttribute.parse(
        false,
        this.#openApiOperation.queryProperties
      );
      this.filterAttributes = RequestSampleAttribute.parse(
        false,
        this.#openApiOperation.filterProperties
      );
      this.sourceFilterAttributes = RequestSampleAttribute.parse(
        false,
        this.#openApiOperation.filterProperties
      );
      this.sortAttributes = RequestSampleAttribute.parse(
        false,
        this.#openApiOperation.sortProperties
      );
      this.sourceSortAttributes = RequestSampleAttribute.parse(
        false,
        this.#openApiOperation.sortProperties
      );
      this.pathAttributes = RequestSampleAttribute.parse(
        false,
        this.#openApiOperation.pathAttributes
      );
      this.returns = RequestSampleAttribute.parse(
        false,
        this.#openApiOperation.response!
      );
      this.returns = this.addReturns();
    }
    return this;
  }

  fromJson(data: {
    id: string;
    name: string;
    description: string;
    path?: string;
    httpMethod?: string;
    methodName?: string;
    notes?: string;
    isListOperation?: boolean;
    isIdempotent?: boolean;
    isRestricted?: boolean;
    isCustomFieldsSupported?: boolean;
    required?: string[] | boolean;
    subDomain?: string;
    pathAttributes?: RequestSampleAttribute[] | undefined;
    queryAttributes?: RequestSampleAttribute[] | undefined;
    sourceQueryAttributes?: RequestSampleAttribute[] | undefined;
    sortAttributes?: RequestSampleAttribute[] | undefined;
    sourceSortAttributes?: RequestSampleAttribute[] | undefined;
    attributes?: RequestSampleAttribute[] | undefined;
    sourceAttributes?: RequestSampleAttribute[] | undefined;
    filterAttributes?: RequestSampleAttribute[] | undefined;
    sourceFilterAttributes?: RequestSampleAttribute[] | undefined;
    returns?: RequestSampleAttribute[] | undefined;
    resourceKey: string;
  }) {
    this.id = data.id;
    this.resourceKey = data.resourceKey;
    this.description = data.description;
    this.path = data.path;
    this.httpMethod = data.httpMethod;
    this.methodName = data.methodName;
    this.notes = data.notes;
    this.isListOperation = data.isListOperation;
    this.isIdempotent = data.isIdempotent;
    this.isRestricted = data.isRestricted;
    this.isCustomFieldsSupported = data.isCustomFieldsSupported;
    this.name = data.name;
    this.attributes = data.attributes;
    this.sourceAttributes = JSON.parse(JSON.stringify(this.attributes));
    this.queryAttributes = data.queryAttributes;
    this.sourceQueryAttributes = data.sourceQueryAttributes;
    this.filterAttributes = data.filterAttributes;
    this.sourceFilterAttributes = data.sourceFilterAttributes;
    this.sortAttributes = data.sortAttributes;
    this.sourceSortAttributes = data.sourceSortAttributes;
    this.pathAttributes = data.pathAttributes;
    this.returns = data.returns;
    this.subDomain = data.subDomain;
    return this;
  }

  addReturns(): RequestSampleAttribute[] {
    const flatReturns: RequestSampleAttribute[] = [];
    this.returns?.forEach((attribute: RequestSampleAttribute) => {
      if (attribute.isArray && !attribute.isResource) {
        flatReturns.push(...(attribute.attributes ?? []));
      } else {
        flatReturns.push(attribute);
      }
    });
    return flatReturns;
  }
}
